import template from './tnt_billing.html';
import controller from './tnt_billing.controller';
import './tnt_billing.scss';

let tntBillingComponent = {
  restrict: 'E',
  bindings: {
  },
  template,
  controller
};

export default tntBillingComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/tnt_billing.component.js